<template>
	<div id="formsContainer">

		<transition name="fade" mode="out-in">



			<page-form :title="$t('pageTitles.maxReached')" :grid="false" v-if="currentPage==='maxreached'" key="maxreached">
				<template v-slot:content>
					<!-- ================================================ -->
					<div class="col4 simpletext">
						<p>{{$t('pageLitteracy.maxReached')}}</p>
					</div>
					<!-- ================================================ -->
				</template>
			</page-form>



			<page-form :grid="true" v-else-if="currentPage==='inscription'" key="inscription">

				<template v-slot:content>
					<!-- ================================================ -->

					<breadcrumbs class="col4" :steps="['registration','store','form','survey','cashback']" :currentStep="0"></breadcrumbs>

					<claim-blocs class="col4" :bloc-type="['email', 'whatsapp', 'sms']" @goto="goto" @mean="setInscriptionMean" :lang="$i18n.locale.slice(0,2)">
						<template v-slot:title>
							<headings titletype="titleh3" class="col4">
								<template v-slot:text>{{$t('sectionTitles.inscription')}}	</template>
							</headings>
						</template>
					</claim-blocs>

					<div class="textintro col4">

						<div class="centeredContent" v-if="$i18n.locale === 'fr_BE' || $i18n.locale === 'fr_LU'">

							<div class="encart">
								En alliant les sachets fraicheur et croquettes Purina ONE, participez à la bonne santé de votre chat tout en le régalant&nbsp;!
							</div>
							<div class="intro">
								<h2>Pourquoi une alimentation mixte est-elle recommandée&nbsp;?</h2>
								<p>C’est <strong>l’une des manières les plus efficaces pour que votre chat reste hydraté</strong>. Par nature, le chat est un petit buveur, lui offrir des sachets fraîcheurs permet de stimuler son hydratation lors du repas.</p>
								<p>C’est également bénéfique aux chats ayant une tendance à l’embonpoint (suite à la stérilisation par exemple). Une alimentation mixte permet <strong>d’équilibrer l’apport en calories.</strong>
								</p>
								<p>Les croquettes, de par leur texture croustillante, permettent de <strong>maintenir des gencives et des dents saines.</strong></p>
								<p><strong>Vous faites plaisir à votre chat</strong>&nbsp;: le mix de croquettes et de sachets fraîcheur Purina® ONE lui apportent les textures et goûts qu’il raffole sans compromis sur son bien-être.</p>
								<p>Développés par les vétérinaires et les nutritionnistes PURINA®, <strong>les croquettes et les sachets fraîcheur PURINA ONE® contiennent tous les nutriments essentiels dont votre chat a besoin.</strong></p>
							</div>

							<a class="btn-link" id="discoverlink" href="https://www.purina.be/fr/marques/purina-one/chat/alimentation-mixte" target="_blank">En savoir plus</a>

						</div>

						<div class="centeredContent" v-else>

							<div class="encart">
								Door het droog en nat kattenvoer te combineren, kunt u bijdragen aan de goede gezondheid en het plezier van uw kat!

							</div>
							<div class="intro">
								<h2>Waarom is een gemengd dieet aanbevolen?</h2>
								<p>Dit is <strong>één van de meest effectieve manieren om ervoor te zorgen dat uw kat gehydrateerd blijft</strong>. Van nature is de kat een kleine drinker, hem nat kattenvoer aanbieden boost zijn hydratatie tijdens de maaltijden.</p>
								<p>Het is ook gunstig voor katten met een neiging tot overgewicht (na sterilisatie bijvoorbeeld). Gemengde voeding helpt <strong>om de calorie-inname in evenwicht te brengen.</strong></p>
								<p>Door de knapperige textuur van brokjes, helpt het om de tanden en <strong>het tandvlees gezond te houden</strong>.</p>
								<p><strong>Je maakt je kat gelukkig</strong>: de mix van brokjes en nat kattenvoer Purina® ONE brengt hem texturen en smaken waar hij van houdt, zonder zijn welzijn in gedrang te brengen.</p>
								<p>Ontwikkeld door onze PURINA® dierenartsen en voedingsdeskundigen, <strong>is het Purina® ONE assortiment bereid met smakelijke, hoogwaardige ingrediënten en biedt het geavanceerde voeding die de gezondheid van uw kat vandaag en morgen helpt ondersteunen</strong>.</p>
							</div>

							<a class="btn-link" id="discoverlink" href="https://www.purina.be/nl/merken/purina-one/kat/gecombineerde-voeding" target="_blank">Lees meer</a>

						</div>

					</div>

					<div class="disclaimer col4">
						{{$t('pageLitteracy.registration.byRegistering')}}
						<a v-if="$i18n.locale==='fr_BE' || $i18n.locale==='fr_LU'" href="https://www.nestle.be/fr/info/declaration-de-confidentialite">{{$t('pageLitteracy.registration.privacyNotice')}}</a>

						<a v-else href="https://www.nestle.be/nl/info/yourdata">{{$t('pageLitteracy.registration.privacyNotice')}}</a>

					</div>
					<!-- ================================================ -->
				</template>
			</page-form>





			<page-form :title="$t('pageTitles.confirmation')" :grid="true" v-else-if="currentPage==='confirminscription'" key="confirminscription">
				<template v-slot:content>
					<!-- ================================================ -->

					<headings titletype="titleh3" class="col4">
						<template v-slot:text>{{$t('pageLitteracy.confirmInscription.thanks')}}</template>
					</headings>

					<spacer :h="1" class="col4"></spacer>

					<div id="confirmSMS" v-if="inscriptionMean==='phone'" class="col4">
						<p>{{$t('pageLitteracy.confirmInscription.smsLine1')}}test</p>
						<p>{{$t('pageLitteracy.confirmInscription.smsLine2')}}</p>
						<p>{{$t('pageLitteracy.confirmInscription.smsLine3')}}</p>
					</div>

					<div id="confirmWhatsapp" v-if="inscriptionMean==='whatsapp'" class="col4">
						<p>{{$t('pageLitteracy.confirmInscription.whatsappLine1')}}</p>
						<p>{{$t('pageLitteracy.confirmInscription.whatsappLine2')}}</p>
						<p>{{$t('pageLitteracy.confirmInscription.whatsappLine3')}}</p>
					</div>

					<div id="confirmMAIL" v-if="inscriptionMean==='email'" class="col4">
						<p>{{$t('pageLitteracy.confirmInscription.mailLine1')}}</p>
						<p>{{$t('pageLitteracy.confirmInscription.mailLine2')}}</p>
						<p>{{$t('pageLitteracy.confirmInscription.mailLine3')}}</p>
					</div>


					<!-- ================================================ -->
				</template>


			</page-form>






			<page-form :title="$t('pageTitles.wrongCode')" :grid="true" v-else-if="currentPage==='wrongcode'" key="wrongcode">
				<template v-slot:content>
					<!-- ================================================ -->
					<div class="col4 simpletext">
						<p>{{$t('pageLitteracy.wrongCode')}}</p>
					</div>
					<!-- ================================================ -->
				</template>

				<template v-slot:nav>
					<nav-buttons :next="{label:$t('pageLitteracy.signup'), dest:'inscription'}" @goto="goto"></nav-buttons>
				</template>

			</page-form>






			<page-form :grid="true" v-else-if="currentPage==='landing'" key="landing">
				<template v-slot:content>
					<!-- ================================================ -->


					<breadcrumbs :steps="['registration','store','form','survey','cashback']" :currentStep="2" class="col4"></breadcrumbs>


					<messages :msgType="messageType" class="col4" v-if="isThereMessage">
						<template v-slot:text>
							<ul>
								<li v-for="(message, index) in messageContent" :key="index">&bull; {{message}}</li>
							</ul>
						</template>
					</messages>


					<p style="text-align: right; font-size:0.8em;" class="col4"><span style="color: red;">*</span> {{$t('inputLabel.mandatoryFields')}}</p>


					<headings titletype="titleh3" class="col4">
						<template v-slot:text>{{$t('pageLitteracy.landing.aboutYou')}}</template>
					</headings>


					<custom-input
					fieldname="firstName"
					:placeholder="$t('inputLabel.firstname.placeholder')"
					inputType="text"
					:label="$t('inputLabel.firstname.label')"
					:isRequired="true"
					:helper="$t('inputLabel.firstname.helper')"
					v-model.lazy:modelValue="fieldsValues.firstname"
					@runCheck="checkIfMustUnlockClaimCashbackButton"
					class=""></custom-input>

					<custom-input
					fieldname="lastName"
					:placeholder="$t('inputLabel.lastname.placeholder')"
					inputType="text"
					:label="$t('inputLabel.lastname.label')"
					:isRequired="true"
					:helper="$t('inputLabel.lastname.helper')"
					v-model.lazy:modelValue="fieldsValues.lastname"
					@runCheck="checkIfMustUnlockClaimCashbackButton"
					class=""></custom-input>

					<custom-input
					fieldname="email"
					:placeholder="$t('inputLabel.email.placeholder')"
					inputType="text"
					:label="$t('inputLabel.email.label')"
					:helper="$t('inputLabel.email.helper')"
					:isRequired="true"
					:disabled="isMailFieldDisabled"
					v-model.lazy:modelValue="fieldsValues.email"
					@runCheck="checkIfMustUnlockClaimCashbackButton"
					></custom-input>

					<custom-input
					fieldname="phoneNumber1"
					:placeholder="$t('inputLabel.phone.placeholder')"
					inputType="tel"
					:label="$t('inputLabel.phone.label')"
					:helper="$t('inputLabel.phone.helper')"
					:isRequired="false"
					:disabled="isPhoneFieldDisabled"
					v-model.lazy:modelValue="fieldsValues.phone1"
					></custom-input>

					<custom-input
					fieldname="IBAN"
					:placeholder="$t('inputLabel.iban.placeholder')"
					inputType="text"
					:label="$t('inputLabel.iban.label')"
					:isRequired="true"
					v-model.lazy:modelValue="fieldsValues.iban"
					@runCheck="checkIfMustUnlockClaimCashbackButton"
					class=""></custom-input>

					<spacer :h="1" class="col4"></spacer>

					<!-- Two "SURVEY" questions -->

					<custom-input
					fieldname="catName"
					:placeholder="$t('temporary.surveyQ424.placeholder')"
					inputType="text"
					:label="$t('temporary.surveyQ424.label')"
					:isRequired="true"
					v-model.lazy:modelValue="fieldsValues.survey.answers424"
					@runCheck="checkIfMustUnlockClaimCashbackButton"
					class=""></custom-input>

					<custom-input
					fieldname="catAge"
					:placeholder="$t('temporary.surveyQ417.placeholder')"
					inputType="date"
					:label="$t('temporary.surveyQ417.label')"
					:isRequired="true"
					v-model.lazy:modelValue="fieldsValues.survey.answers417"
					@runCheck="checkIfMustUnlockClaimCashbackButton"></custom-input>

<!--          <div class="field"></div>
          &lt;!&ndash; Add possibility to push custom message to custom-input &ndash;&gt;
          <div class="errorMessage field" v-if="dateMessage" style="margin: 0">{{dateMessage}}</div>-->


          <!-- Proof of purchase -->

          <headings titletype="titleh3" class="col4">
          	<template v-slot:text>{{$t('pageLitteracy.landing.popTitle')}}</template>
          </headings>

          <custom-select
          fieldname="selectProduct"
          :placeholder="$t('inputLabel.popitem.placeholder')"
          :label="$t('inputLabel.popitem.label')"
          :helper="$t('inputLabel.popitem.helper')"
          data-from="popitems"
          identifier="id"
          description="description"
          :isRequired="true"
          :isReparticipation="reparticipation"
          v-model.lazy:modelValue='fieldsValues.popitem'
          @runCheck="checkIfMustUnlockClaimCashbackButton"
          ></custom-select>

          <upload
          post-upload-url-prop="/participations/upload"
          :idLead="lead.id"
          :isRequired="true"
          @runCheck="checkIfMustUnlockClaimCashbackButton"
          ></upload>

          <spacer :h="1" class="col4"></spacer>

          <!-- General conditions, Opt-in-->

          <!-- Custom Checkbox General Conditions -->
          <custom-checkbox
          fieldname="conditions"
          inputid="demoConditionsCB"
          helper=""
          :isRequired="true"
          v-model="fieldsValues.cg"
          @runCheck="checkIfMustUnlockClaimCashbackButton"
          special-style="vcheck"
          class="col2"
          >
          <template v-slot:msg>
          	{{$t('pageLitteracy.landing.agree')}} <a href="Terms and conditions" @click.prevent="openConditions()" download>{{$t('pageLitteracy.landing.termsAndConditions')}}</a>
          </template>
      </custom-checkbox>



      <!-- Custom Checkbox Optin -->
      <custom-checkbox
      fieldname="optin"
      inputid="optin"
      :helper="$t('pageLitteracy.landing.moreInfoHelper')"
      v-model="fieldsValues.optin"
      special-style="vcheck"
      class="col2">
      <template v-slot:msg><div v-html="$t('pageLitteracy.landing.moreInfo')"></div></template>
  </custom-checkbox>
</template>


<template v-slot:nav>
	<nav-buttons
	:next="{
		label:'Cashback',
		dest:'choicesurvey',
		disabled: !isClaimCashbackButtonActive
	}"
	@goto="goto"></nav-buttons>


	<div class="textintro col4" style="margin-top:80px;">

		<div class="centeredContent" v-if="$i18n.locale === 'fr_BE' || $i18n.locale === 'fr_LU'">

			<div class="encart">
				En alliant les sachets fraicheur et croquettes Purina ONE, participez à la bonne santé de votre chat tout en le régalant&nbsp;!
			</div>

			<div class="intro">
				<h2>Pourquoi une alimentation mixte est-elle recommandée&nbsp;?</h2>

				<p>C’est <strong>l’une des manières les plus efficaces pour que votre chat reste hydraté</strong>. Par nature, le chat est un petit buveur, lui offrir des sachets fraîcheurs permet de stimuler son hydratation lors du repas.</p>
				<p>C’est également bénéfique aux chats ayant une tendance à l’embonpoint (suite à la stérilisation par exemple). Une alimentation mixte permet <strong>d’équilibrer l’apport en calories.</strong>
				</p>
				<p>Les croquettes, de par leur texture croustillante, permettent de <strong>maintenir des gencives et des dents saines.</strong></p>
				<p><strong>Vous faites plaisir à votre chat</strong>&nbsp;: le mix de croquettes et de sachets fraîcheur Purina® ONE lui apportent les textures et goûts qu’il raffole sans compromis sur son bien-être.</p>
				<p>Développés par les vétérinaires et les nutritionnistes PURINA®, <strong>les croquettes et les sachets fraîcheur PURINA ONE® contiennent tous les nutriments essentiels dont votre chat a besoin.</strong></p>
			</div>

			<a class="btn-link" id="discoverlink" target="_blank" href="https://www.purina.be/fr/marques/purina-one/chat/alimentation-mixte">En savoir plus</a>

		</div>

		<div class="centeredContent" v-else>

			<div class="encart">
				Door het droog en nat kattenvoer te combineren, kunt u bijdragen aan de goede gezondheid en het plezier van uw kat!

			</div>
			<div class="intro">

				<h2>Waarom is een gemengd dieet aanbevolen?</h2>

				<p>Dit is <strong>één van de meest effectieve manieren om ervoor te zorgen dat uw kat gehydrateerd blijft</strong>. Van nature is de kat een kleine drinker, hem nat kattenvoer aanbieden boost zijn hydratatie tijdens de maaltijden.</p>
				<p>Het is ook gunstig voor katten met een neiging tot overgewicht (na sterilisatie bijvoorbeeld). Gemengde voeding helpt <strong>om de calorie-inname in evenwicht te brengen.</strong></p>
				<p>Door de knapperige textuur van brokjes, helpt het om de tanden en <strong>het tandvlees gezond te houden</strong>.</p>
				<p><strong>Je maakt je kat gelukkig</strong>: de mix van brokjes en nat kattenvoer Purina® ONE brengt hem texturen en smaken waar hij van houdt, zonder zijn welzijn in gedrang te brengen.</p>
				<p>Ontwikkeld door onze PURINA® dierenartsen en voedingsdeskundigen, <strong>is het Purina® ONE assortiment bereid met smakelijke, hoogwaardige ingrediënten en biedt het geavanceerde voeding die de gezondheid van uw kat vandaag en morgen helpt ondersteunen</strong>.</p>


			</div>

			<a class="btn-link" id="discoverlink" target="_blank" href="https://www.purina.be/nl/merken/purina-one/kat/gecombineerde-voeding">Lees meer</a>

		</div>


		<nav-buttons
		:next="{
			label:'Cashback',
			dest:'choicesurvey',
			disabled: !isClaimCashbackButtonActive
		}"
		@goto="goto"></nav-buttons>


	</div>

</template>

</page-form>













<page-form :title="$t('pageLitteracy.choiceSurvey.title')" :grid="true" v-else-if="currentPage==='choicesurvey'" key="choicesurvey">
	<template v-slot:content>
		<breadcrumbs :steps="['registration','store','form','survey','cashback']" :currentStep="3" class="col4"></breadcrumbs>
		<headings titletype="titleh3" class="col4">
			<template v-slot:text>{{$t('pageLitteracy.choiceSurvey.fillSurveyIncite')}}</template>
		</headings>
		<!-- ================================ -->
	</template>
	<template v-slot:nav>

		<nav-buttons @goto="goto" class="specialInversion">
			<template v-slot:customButton>
				<button @click="goto('survey'); setSurvey('Y');" :disabled="skipButtonIsClicked" class="btnsurvey">{{$t('navigation.doSurvey')}}</button>
				<button @click="setSurvey('N')" :disabled="skipButtonIsClicked" class="btnskip">{{$t('navigation.skipSurvey')}}</button>
				<button @click="goto('landing');" class="btnsurvey">{{$t('navigation.previous')}}</button>
			</template>
		</nav-buttons>
	</template>
</page-form>










<page-form :title="$t('pageLitteracy.survey.title')" :grid="true" v-else-if="currentPage==='survey'" key="survey">
	<template v-slot:content>

		<breadcrumbs :steps="['registration','store','form','survey','cashback']" :currentStep="3" class="col4"></breadcrumbs>

		<headings titletype="titleh3" class="col4">
			<template v-slot:text>{{$t('pageLitteracy.survey.aboutCat')}}</template>
		</headings>


		<!-- ================== SURVEY Q418 & Q419 ================== -->
		<survey-custom-select
		fieldname="answer"
		:placeholder="$t('temporary.surveyQ418.placeholder')"
		:label="$t('temporary.surveyQ418.label')"
		data-from="dryandwetfoodthesameday"
		code="id"
		description="description"
		:helper="$t('temporary.surveyQ418.helper')"
		:isRequired="false"
		:isReparticipation="reparticipation"
		v-model.lazy:modelValue="fieldsValues.survey.answers418"
		class="col2"
		>
	</survey-custom-select>
	<!-- This field appears if "Nee/Non" is selected -->
	<survey-custom-select
	v-if="fieldsValues.survey.answers418 === 399 || fieldsValues.survey.answers418 === '399'"
	fieldname="lorem"
	:placeholder="$t('temporary.surveyQ419.placeholder')"
	:label="$t('temporary.surveyQ419.label')"
	data-from="isitmainlydryandwetfood"
	code="id"
	description="description"
	:helper="$t('temporary.surveyQ419.helper')"
	:isReparticipation="reparticipation"
	v-model.lazy:modelValue="fieldsValues.survey.answers419"
	@runCheck="checkIfMustUnlockClaimCashbackButton"
	class="col2"
	>
</survey-custom-select>
<spacer :h="0" class="col4"></spacer>






<!-- ================== SURVEY Q420 & Q421 ================== -->
<survey-custom-select
fieldname="answer"
:placeholder="$t('temporary.surveyQ420.placeholder')"
:label="$t('temporary.surveyQ420.label')"
data-from="givepurinaoonedrycatfood"
code="id"
description="description"
:helper="$t('temporary.surveyQ420.helper')"
:isRequired="false"
:isReparticipation="reparticipation"
v-model.lazy:modelValue="fieldsValues.survey.answers420"
class="col2"
>
</survey-custom-select>
<!-- This field appears if "Nee/Non" is selected -->
<custom-input
v-if="fieldsValues.survey.answers420 === 403 || fieldsValues.survey.answers420 === '403'"
fieldname="lorem"
:placeholder="$t('temporary.surveyQ421.placeholder')"
inputType="text"
:label="$t('temporary.surveyQ421.label')"
:helper="$t('temporary.surveyQ421.helper')"
v-model.lazy:modelValue="fieldsValues.survey.answers421"
@runCheck="checkIfMustUnlockClaimCashbackButton"
class="col2"></custom-input>
<spacer :h="0" class="col4"></spacer>


<!-- ================== SURVEY Q422 & Q423 ================== -->
<survey-custom-select
fieldname="answer"
:placeholder="$t('temporary.surveyQ422.placeholder')"
:label="$t('temporary.surveyQ422.label')"
data-from="givepurinaoonewetcatfood"
code="id"
description="description"
:helper="$t('temporary.surveyQ422.helper')"
:isRequired="false"
:isReparticipation="reparticipation"
v-model.lazy:modelValue="fieldsValues.survey.answers422"
class="col2"
>
</survey-custom-select>
<!-- This field appears if "Nee/Non" is selected -->
<custom-input
v-if="fieldsValues.survey.answers422 === 405 || fieldsValues.survey.answers422 === '405'"
fieldname="lorem"
:placeholder="$t('temporary.surveyQ423.placeholder')"
inputType="text"
:label="$t('temporary.surveyQ423.label')"
:helper="$t('temporary.surveyQ423.helper')"
v-model.lazy:modelValue="fieldsValues.survey.answers423"
@runCheck="checkIfMustUnlockClaimCashbackButton"
class="col2"></custom-input>
<spacer :h="0" class="col4"></spacer>


<!-- ================================================ -->
</template>


<template v-slot:nav>
	<nav-buttons @goto="goto">

		<template v-slot:customButton>
			<button @click="sendParticipation, setSurvey('N')" :disabled="!isClaimCashbackButtonActive">{{$t('pageLitteracy.landing.claimCashback')}}</button>
		</template>

	</nav-buttons>
</template>


</page-form>












<page-form :title="$t('pageTitles.alreadySend')" :grid="true" v-else-if="currentPage==='participated'" key="participated">
	<template v-slot:content>
		<!-- ================================================ -->
		<div class="col4 simpletext">
			<p>{{$t('pageLitteracy.alreadySend')}}</p>
		</div>
		<!-- ================================================ -->
	</template>
</page-form>








<page-form :title="$t('pageTitles.beforeStart')" :grid="true" v-else-if="currentPage==='beforeStart'" key="beforeStart">
	<template v-slot:content>

		<div class="col4 simpletext">
			<p>{{$t('pageLitteracy.beforeStart.text')}} {{actionStartDate}}.</p>
		</div>

	</template>
</page-form>






<page-form :title="$t('pageTitles.actionEnded')" :grid="true" v-else-if="currentPage==='actionEnded'" key="actionEnded">
	<template v-slot:content>

		<div class="col4 simpletext">
			<p>{{$t('pageLitteracy.actionEnded.text')}}</p>
		</div>

	</template>
</page-form>











<page-form :title="$t('pageLitteracy.confirmation.title')" :grid="true" v-else-if="currentPage==='confirmation'" key="confirmation">
	<template v-slot:content>

		<breadcrumbs :steps="['registration','store','form','survey','cashback']" :currentStep="4" class="col4"></breadcrumbs>
		<!-- ================================================ -->
		<div class="col4 simpletext">

			<p>{{$t('pageLitteracy.confirmation.textes.p1')}}</p>
			<p>{{$t('pageLitteracy.confirmation.textes.p2')}}</p>
			<p>{{$t('pageLitteracy.confirmation.textes.p3')}}</p>
			<p>
				<em>{{$t('pageLitteracy.confirmation.textes.p4')}}</em>
			</p>
		</div>
		<!-- ================================================ -->
	</template>
</page-form>






</transition>

<div class="debug" v-if="isDevNavVisible">
	<div>NAVIGATION — Currently displaying: <strong>{{currentPage}}</strong> — Direct links to page:</div>
	<ul>
		<li @click="goto('beforeStart')">beforeStart</li>
		<li @click="goto('inscription')">Inscription</li>
		<li @click="goto('confirminscription')">Mail confirmation</li>
		<li @click="goto('landing')">landing</li>
		<li @click="goto('choicesurvey')">Choice Survey</li>
		<li @click="goto('survey')">Survey</li>
		<li @click="goto('confirmation')">Confirmation</li>
		<li @click="goto('maxreached')">Max participation</li>
		<li @click="goto('wrongcode')">Wrong code</li>
		<li @click="goto('participated')">Participation already sent</li>
		<li @click="goto('actionEnded')">actionEnded</li>
	</ul>
</div>




</div>
</template>

<!-- ================================================================================== -->

<script>

	import PageForm from '@/components/PageForm.vue';
	import Messages from '@/components/Messages.vue';
	import NavButtons from '@/components/NavButtons.vue';
	import ClaimBlocs from '@/components/ClaimBlocs.vue';
	import Headings from '@/components/Headings.vue';
	import CustomInput from "@/components/CustomInput";
	import CustomCheckbox from '@/components/CustomCheckbox.vue';
	import CustomSelect from '@/components/CustomSelect.vue';
	// import CustomRadio from '@/components/CustomRadio.vue';
	import Spacer from '@/components/Spacer.vue';
	import Breadcrumbs from '@/components/Breadcrumbs.vue';
	import Upload from "@/components/Upload";
	import SurveyCustomSelect from '@/components/SurveyCustomSelect.vue';
	import pixel from "../mixins/pixel";
	export default {
		name:"Form",
		mixins: [pixel],
		data () {
			return {
				skipButtonIsClicked: false,
				// fait apparaitre en bas de page un panneau avec un lien vers chaque page, pour test.
				isDevNavVisible: false,
				keyChain: [],
				// …by putting a ?cheat=on in the url
				isClaimCashbackButtonActive: false,
				inscriptionMean : '',
				lead : {},
				currentPage : "home",
				keyFromUrl: '',
				ownerData: {},
				reparticipation: false,
				survey: false,
				dateMessage: null,

				isThereMessage: false,
				messageContent: [],
				messageType: "alert",

				isMailFieldDisabled: false,
				isPhoneFieldDisabled: false,

				fieldsValidity: {
					firstName: false,
					lastName: false,
					email: false,
					conditions: false,
					file: false,
					selectProduct: false,
				},

				surveyMustBeFilled : 'N',
				fieldsValues : {
					bic:'',
					iban:'',
					idTitle: '',
					idGenre: '',
					uniqueCode : '',
					firstname: '',
					lastname: '',
					email: '',
					popitem: '',
					popitem2: {
						code: '',
						description: ''
					},

					retailer: '',
					language: 'FR',
					birthdate : '',
					phone1: '',
					phone2: '',
					adress: {
						adr1 : '',
						adr2 : '',
						number : '',
						box : '',
						country : 'BE',
						postalcode : '',
						town : ''
					},
					societe1 : '',
					societe2 : '',
					vatCountry: '',
					vatCode : '',
					confidentiality :'',
					cg : '',
					survey:{
						answers417: '', // cat's age
						answers418: '', // Q1
						answers419: '', // Q1 alt
						answers420: '', // Q2
						answers421: '', // Q2 alt
						answers422: '', // Q3
						answers423: '', // Q3 alt
						answers424: '' // cat's name
					}
				}
			};
		},

		computed: {

			actionStartDate : function(){
				return this.formatDate(this.lead.golivedate);
			},
			actionEndDate : function(){
				return this.formatDate(this.lead.lastnewparticipationdate);
			},
			isMaxParticipationReached: function(){
				console.log("--------------------------");
				console.log("Il reste " + this.lead.inscriptions_left + " inscriptions disponibles");
				console.log("Il reste " + this.lead.participations_left + " participations disponibles");
				console.log("--------------------------");
				return this.lead.participations_left <= 0;
			},
		},

		components: {
			NavButtons,
			ClaimBlocs,
			Headings,
			Breadcrumbs,
			CustomInput,
			CustomSelect,
			CustomCheckbox,
			Messages,
			Spacer,
			SurveyCustomSelect,
			Upload,
			PageForm,
		},

		methods: {

			setSurvey(val){
				this.surveyMustBeFilled = val;
				if (val ==="N"){
					this.sendParticipation();
				}
				this.survey = true;
			},

			setInscriptionMean(mean){
				this.inscriptionMean = mean;
			},

			formatDate(oldDate){
				let dateArray = oldDate.split("-");
				return dateArray[2] + "/" + dateArray[1] + "/" + dateArray[0];
			},

			goto(dest){
				console.log("%cI received '" + dest + "' as a destination","color:#999;");
				this.logCustomEvent(dest);
				this.currentPage = dest;
			},

			reload(){
				console.clear();
				this.goto('home');
				this.checkIfMaxParticipation();
			},

			openConditions (){
				window.open("https://cashback.promolife.be/purina-one/files/conditions_"+ this.$i18n.locale.toLowerCase() +".pdf");
			},

			getKeyFromUrl(){
				console.log("Looking in the URL for a key");
				let urlParams = new URLSearchParams(window.location.search);
				let key = '';
				if (urlParams.has('key')){
					key = urlParams.get('key');
					console.log("--> Found a key: " + key);
					console.log("--------------------------");
				}else{
					console.log("--> Missing key");
					console.log("--------------------------");
				}
				return key;
			},



			/* GETTING THE INFO ABOUT THE ACTION */
			getLead(refhd){
				console.log("Getting Lead and looking for the key");
				this.axios.get(
					`/lead/${refhd}`
					)
				.then(res => {
					console.log("I managed to get the lead! ");
					console.log(res.data);
					this.lead = res.data;
					// check if action has started/ended and proceed…
					this.checkIfInDate();
				})
				.catch(error => {
					console.error("I cannot get the Lead");
					console.log(error.response.data.errors);
				})
				.then(()=>{
				});
			},

			checkIfInDate(){
				let dateOfNow = new Date();
				let actionStartDate = new Date(this.lead.participationbegindate);
				let actionEndDate = new Date(this.lead.participationenddate);

				if(dateOfNow.getTime() > actionStartDate.getTime() &&
					dateOfNow.getTime() < actionEndDate.getTime()){
					console.log("Now is a good time to participate");
				this.checkForKeyInUrl();
			}else if(dateOfNow.getTime() < actionStartDate.getTime()){
				console.log("It's too soon!");
				this.goto('beforeStart');
			}
			else if(dateOfNow.getTime() > actionEndDate.getTime()){
				console.log("It's too late!");
				this.goto('actionEnded');
			}else{
				console.log("Are you travelling in time?");
			}

		},


		checkIfMustUnlockClaimCashbackButton(val){
			console.log("One input is sending an object value:");
			console.log(val);
				// setting the new property :
				this.fieldsValidity[val.fieldname] = val.valid;
				this.$nextTick(function () {
					this.checkAllRequiredFields();
				})
			},

			checkAllRequiredFields(){
				console.group("All Fields on TRUE? --> button unlocked");
				// Names of the fields to check (in this form) : firstName, lastName, email, select_product, select_retailer, cr1, cr2, conditions

				// "conditions" is appart and value must be taken elsewhere:
				this.fieldsValidity.conditions = Boolean(this.fieldsValues.cg);
				let allRequiredFieldsAreValid = true;
				for (let item in this.fieldsValidity){
					// just for console embellishement :
					let color = (this.fieldsValidity[item])?"#090":"#900";
					console.log(`%c ${item}: ${this.fieldsValidity[item]}`, `color:${color}`);
					if (this.fieldsValidity[item]===false){
						allRequiredFieldsAreValid = false;
					}
				}
				// console.log("Mockup test: always TRUE");
				if(allRequiredFieldsAreValid && this.fieldsValues.survey.answers424 != '' && this.fieldsValues.survey.answers417 != ''){
					this.isClaimCashbackButtonActive = true;
					console.log("Button must be unlocked");
				}else{
					this.isClaimCashbackButtonActive = false;
					console.log("Button must be locked");
				}
				console.groupEnd();
			},

			/* ------------------------------ */

			checkForKeyInUrl(){
				this.keyFromUrl = this.getKeyFromUrl();
				if (this.keyFromUrl){
					this.getOwnerData();
				}else{
					if (this.isMaxParticipationReached){
						this.goto('maxreached');
					}else{
						this.goto('inscription');
					}

				}
			},

			/* ------------------------------ */

			checkIfalreadyParticipated(){
				console.log("===================");
				console.log(this.ownerData);
				console.log(this.bigOwnerData);
				console.log("===================");
				/* check if already participated (status === 30) or if reparticipation */
				if (this.ownerData.status !== "30" || this.reparticipation){
					console.log("Participation has not been sent yet or this is a reparticipation.");

					console.log((this.reparticipation)?"(This is a reparticipation)":"(This is not a reparticipation)");



					console.log("--------------------------");
					this.goto('landing');
				}else{
					console.log("Participation already sent and this is not a reparticipation.");
					console.log("--------------------------");
					this.goto('participated');
				}
			},

			/* ------------------------------ */

			putDataInFields(){
				console.group("Putting data into fields");
				if(this.reparticipation){
					console.log("This is a reparticipation");
					let categories = Object.keys(this.bigOwnerData);
					categories.forEach((category) => {

						if(category === 'ParticipationMetaData'){
							this.bigOwnerData[category].forEach((item, index) => {
								this.fieldsValues.survey[`answers${index}`] = item.idleadtmdv;
							});
						}else{
							let keys = Object.keys(this.bigOwnerData[category]);
							if(typeof this.bigOwnerData[category] === 'object'){
								keys.forEach((key) => {
									this.fieldsValues[key] = this.bigOwnerData[category][key];
								});
								console.group("fieldsValues");
								console.log(this.fieldsValues);
								console.groupEnd();
							}
						}
					});
				} else {
					if(this.ownerData.email){
						console.log("I've found an email to put into a field");
						this.fieldsValues.email = this.ownerData.email;
						this.isMailFieldDisabled = true;
						console.log("--------------------------");
					}
					if(this.ownerData.phonenumber1){
						console.log("I've found a phone number to put into a field");
						this.fieldsValues.phone1 = this.ownerData.phonenumber1;
						this.isPhoneFieldDisabled = true;
						console.log("--------------------------");
					}
				}
				console.groupEnd();
			},

			/* ------------------------------ */

			getOwnerData(){
				console.group("Get Owner Data");
				this.axios.get(
					`/participationOwner/${this.keyFromUrl}?lang=${this.$i18n.locale.slice(0,2)}`
					)
				.then(res => {
					console.log("I managed to get an answer for the owner ID: ");

					if (res.data){
						if(Array.isArray(res.data)){
							// If res is a vue proxy
							console.log("res.data is an array:");
							console.log(res.data[0]);

							// reparticipation case
							if(res.data[0].reparticipation){
								this.ownerData = res.data[0]["ParticipationOwner"];
								this.bigOwnerData = res.data[0];
								this.reparticipation = true;
							}else{
								this.ownerData = res.data[0];
							}

						}else{
							// if res is an object
							console.log("res.data is an object:");
							console.log(res.data);
							// reparticipation case
							if(res.data.reparticipation) {
								this.ownerData = res.data["ParticipationOwner"];
								this.bigOwnerData = res.data;
								this.reparticipation = true;
							} else {
								this.ownerData = res.data;
							}
						}

						// So we have ownerData. Now…
						this.setLang(this.ownerData.isolanguagecode);
						if(this.isMaxParticipationReached && !this.reparticipation){
							this.goto('maxreached');
						}else{
							this.putDataInFields();
						}
						// Continue participation process…
						this.checkIfalreadyParticipated();

					}else{
						console.log("there is no participation owner for this key");
						this.goto('wrongcode');
					}
				})
				.catch(error => {
					console.error("Sorry, no answer from the API");
					console.log(error.response.data.errors);
					console.log("--------------------------");
					this.goto('wrongcode');
				})
				.then(()=>{
					console.groupEnd();
				});
			},

			setLang (lang) {
				lang = lang.toLowerCase();
				console.log("::: Change lang to: "+ lang + " :::");
				if (lang === "fr"){
					this.$i18n.locale = 'fr_BE';
				}else{
					this.$i18n.locale = 'nl_BE';
				}
			},

			composeData(){
				let data = {};
				/* prep of the DATA */

				data = {
					"idLeadManagement": this.lead.id,
					"ParticipationOwner": {
						"idParticipationOwner": this.ownerData.id,
						"idTitle": "Mr",
						"idGender": "H",
						"phoneNumber1": this.fieldsValues.phone1,
						"lastName": this.fieldsValues.lastname,
						"firstName": this.fieldsValues.firstname,
						"email": this.fieldsValues.email,
						"IBAN": this.fieldsValues.iban,
						"optin": 1,
						"generalCondition": this.fieldsValues.cg,
						"countryCode": this.fieldsValues.adress.country,
						"ISOLanguageCode": this.fieldsValues.language,
						"lang": this.$i18n.locale.slice(0,2),
					},
					"Participation": {
						"idParticipationType": 1,
						'fingerprint': 'v2.cfAGmgqRuc1r8C3rr3GK.vfPuVjq0wC3BMTlg_606174c1705d61.27931079'
					},
					"ProofOfPurchaseDetailConsumer": {
						"idPOPItem": this.fieldsValues.popitem
					},
					"ParticipationMetaData": [
					{
						"idLeadTMD": 1,
						"idLeadTMDV": this.survey ? 1 : 2
					},

					// PURINA

					// question : How old is you cat
					// Input free text
					{
						"idLeadTMD" : 417,
						"idLeadTMDV" : '',
						"answer": this.fieldsValues.survey.answers417
					},

					// question : Do you usually feed your cat dry or wet food ?
					// dropdown
					{
						"idLeadTMD" : 418,
						"idLeadTMDV" : parseInt(this.fieldsValues.survey.answers418)
					},

          // question : Do you mainly give your cat Purina ONE wet cat food?
          // Dropdown
          {
          	"idLeadTMD" : 422,
          	"idLeadTMDV" : parseInt(this.fieldsValues.survey.answers422)
          },

					//	question : Do you mainly give your cat Purina ONE dry cat food?
					// dropdown
					{
						"idLeadTMD" : 420,
						"idLeadTMDV" : parseInt(this.fieldsValues.survey.answers420)
					},

					// question : Quel est le nom de votre chat ?
					// Input free text
					{
						"idLeadTMD" : 424,
						"idLeadTMDV" : '',
						"answer": this.fieldsValues.survey.answers424
					},

					]
				};

				if(this.fieldsValues.survey.answers419 !== '') {
          // question : If not, is it mainly dry or wet
          // dropdown
          data.ParticipationMetaData.push({
          	"idLeadTMD" : 419,
          	"idLeadTMDV" : parseInt(this.fieldsValues.survey.answers419)
          });
      }

      if(this.fieldsValues.survey.answers421 !== '') {
          // question : If not, what brand(s) do you mainly give? Do you mainly give your cat Purina ONE dry cat food?
          // Input free text
          data.ParticipationMetaData.push({
          	"idLeadTMD" : 421,
          	"idLeadTMDV" : '',
          	"answer": this.fieldsValues.survey.answers421
          });
      }

      if(this.fieldsValues.survey.answers423 !== '') {
          // question : If not, what brand do you primarily give ?
          // Input free text
          data.ParticipationMetaData.push({
          	"idLeadTMD" : 423,
          	"idLeadTMDV" : '',
          	"answer": this.fieldsValues.survey.answers423
          });
      }

      return data;
  },

  sendParticipation(){
  	/* deactive button and sending form => only if field e-mail OR phone is validated ! */
  	/* There will be lost clicks… */
  	this.isClaimCashbackButtonActive = false;

  	let data = this.composeData();
  	console.log("Before posting, what did I received from composeData() ?");
  	console.log(data);
  	/* send fieldsvalues to API */
  	this.axios.post(
  		`/participation`,
  		data
  		)
  	.then(res => {
  		console.log("I managed to POST the participation! ");
  		console.log(res.data);
  		this.goto('confirmation');
  	})
  	.catch(error => {
  		console.log("An error has occured: ", error);

					// redirection to first page
					this.goto('landing');

					// if "notifications" key is present
					if(error.response.data.notifications.length > 0){
						this.displayMessage(error.response.data.notifications, 'alert');
					}else{
						// displaying message instead
						let arrayMessage = [];
						arrayMessage.push(error.response.data.message);
						this.displayMessage(arrayMessage, 'alert');
					}
					/* reactivate buttons to allow re-submission */
					this.isClaimCashbackButtonActive = true;
				});
  },

  displayMessage(message, mode='info') {
  	console.log("Displaying message");
  	this.isThereMessage = true;
  	this.messageContent = message;
  	this.messageType = mode;
  },

  hideMessage() {
  	this.isThereMessage = false;
  },

},

beforeMount(){
	console.clear();
			this.getLead(48463); // prod
			// this.getLead(48500); // acceptance
		},
	}
</script>

<!-- ================================================================================== -->

<style lang="scss" scoped>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s, height .5s ease-in-out;
	}
	.fade-enter-from,
	.fade-leave-to {
		opacity: 0;
		height:0;
	}
/*
.fade-enter-to,
.fade-leave-from {
	height:100%;
	opacity:1;
}
*/



</style>
